import { useGetUrlParams } from "../shared/hooks/useGetUrlParams";
import { Navigate } from "react-router-dom";
type TLinkRedirectProps = {
  urlTo: string;
  param: string;
  fallbackUrl: string;
};
function LinkRedirect(props: TLinkRedirectProps) {
  const { urlTo, param, fallbackUrl } = props;
  return (
    <>
      {useGetUrlParams(param) ? (
        <Navigate to={`${urlTo}/${useGetUrlParams(param)}`} />
      ) : (
        <Navigate to={fallbackUrl} />
      )}
    </>
  );
}

export default LinkRedirect;
